import styled from "@emotion/styled"
import { PButton, PText } from "@porsche-design-system/components-react"
import { useContext } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { ButtonGroup } from "src/components"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { newsListMessages as messages } from "./newsList.messages"

interface NewsDeleteModalProps {
	onConfirm: () => void
	title: string
}

export const NewsDeleteModal = ({ id, modalProps }: ModalProps<NewsDeleteModalProps>) => {
	const { formatMessage } = useIntl()
	const { hideModal } = useContext(ModalContext)

	const onCancel = () => hideModal(id)

	const onConfirm = () => {
		modalProps.onConfirm()
		hideModal(id)
	}

	return (
		<Modal id={id} heading={formatMessage(messages.deleteModalTitle)} disableBackdropClick>
			<ModalContent>
				<PText>
					<FormattedMessage {...messages.deleteModalMessage} values={{ title: modalProps.title }} />
				</PText>
				<ButtonGroup>
					<PButton data-testid="news-delete-modal-confirm-button" onClick={onConfirm}>
						<FormattedMessage {...messages.deleteModalConfirm} />
					</PButton>
					<PButton
						data-testid="news-delete-modal-cancel-button"
						type="button"
						variant="secondary"
						onClick={onCancel}
					>
						<FormattedMessage {...messages.deleteModalCancel} />
					</PButton>
				</ButtonGroup>
			</ModalContent>
		</Modal>
	)
}

const ModalContent = styled.div`
	max-width: 40rem;
`
